import { render, staticRenderFns } from "./EditThirdPartyOccupant.vue?vue&type=template&id=48b27241"
import script from "./EditThirdPartyOccupant.vue?vue&type=script&lang=js"
export * from "./EditThirdPartyOccupant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports